/**
 * @file legacy 用户 Store 兼容出口
 * @description 保持存量 `@/pinia/user` 引用不变，实际使用 monorepo 统一用户 Store。
 */

import { useUserStore, useUserStoreOutside } from '@h5-journey/stores'

export { useUserStore, useUserStoreOutside }

const legacyUserSessionKeys = ['mobile', 'loginToken', 'memberId', 'loginId']

/** 读取 legacy 独立 session 字段形成的用户快照。 */
export const getLegacyUserSession = () =>
  legacyUserSessionKeys.reduce((userInfo, key) => {
    userInfo[key] = sessionStorage.getItem(key) || ''
    return userInfo
  }, {})

/**
 * 将统一 Store 的核心用户字段镜像到 legacy sessionStorage。
 * @param {Object} userInfo 用户信息
 * @param {Object} options 同步选项
 * @param {boolean} options.clearMissing 是否清理本次未返回的历史字段
 */
export const syncLegacyUserSession = (userInfo = {}, { clearMissing = true } = {}) => {
  legacyUserSessionKeys.forEach(key => {
    const value = userInfo?.[key]
    if (value !== undefined && value !== null && String(value)) {
      sessionStorage.setItem(key, String(value))
    } else if (clearMissing) {
      sessionStorage.removeItem(key)
    }
  })
}

/**
 * legacy 登录态统一写入口：Store 为主，sessionStorage 仅作存量兼容镜像。
 */
export const setLegacyUserInfo = (userInfo = {}, options) => {
  useUserStoreOutside().setUserInfo(userInfo)
  syncLegacyUserSession(userInfo, options)
}

/**
 * legacy 登录态统一清理出口：重置统一 Store（含 localStorage 记住登录态）并清理 sessionStorage 镜像键。
 */
export const clearLegacyUserInfo = () => {
  useUserStoreOutside().clearUserInfo()
  legacyUserSessionKeys.forEach(key => sessionStorage.removeItem(key))
}
